import React from "react";
import styled from "styled-components";

const PrimaryButton = ({ text, href, newTab }) => {
  return (
    <PrimaryButtonBox href={href} target={newTab && "_blank"}>
      {text}
    </PrimaryButtonBox>
  );
};

export default PrimaryButton;

export const PrimaryButtonBox = styled.a`
  margin-right: 10px;
  /* padding: 15px; */
  padding: 15px 50px;
  /* width: 100%; */
  border-radius: 10px;
  color: var(--blackgrey);
  background-color: var(--primary);
  text-align: center;
  text-decoration: none;
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  &:hover {
    transition: all 0.3s ease-out;
    background-color: transparent;
    color: var(--secondary);
    border: 1px solid var(--primary);
  }
`;
